module.exports = __webpack_public_path__ + "img/cx.cxb7e461d.svg";